const GET_PROFILE_ALBUM_REQUEST = 'GET_PROFILE_ALBUM_REQUEST';
const GET_PROFILE_ALBUM_SUCCESS = 'GET_PROFILE_ALBUM_SUCCESS';
const GET_PROFILE_ALBUM_FAILURE = 'GET_PROFILE_ALBUM_FAILURE';

import * as backend from 'backend-helpers/profileAlbum';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: null,
    stats: {},
    online: null,
    memberPhotos: {
        list: [],
        totalCount: 0
    }
};

export default function profileAlbum(state = initState, action) {
    if (action.type === GET_PROFILE_ALBUM_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    if (action.type === GET_PROFILE_ALBUM_FAILURE) {
        let {error, ...rest} = action;

        console.log('GET_PROFILE_ALBUM_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    return state;
}

export function getProfileAlbum(nick) {
    return {
        types: [GET_PROFILE_ALBUM_REQUEST, GET_PROFILE_ALBUM_SUCCESS, GET_PROFILE_ALBUM_FAILURE],
        promise: backend.getProfileAlbum(nick)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileAlbum.js